import React from 'react';

/**
 * UN'ICONA FONTAWESOME SENZA FONTAWESOME A OGNI DISEGNO.
 *
 * <FontAwesomeIcon> rifa' tutto il lavoro a ogni disegno: copia le opzioni,
 * converte le classi, costruisce l'albero astratto e poi l'SVG. Per una
 * manciata di icone non si nota; nell'elenco dei campionati ce ne sono una
 * per riga, e con un palinsesto vero sono un migliaio e mezzo. Misurato su un
 * telefono lento: quasi due secondi solo per loro all'apertura della pagina.
 *
 * Questa scrive direttamente lo stesso SVG che scriverebbe FontAwesome (stesse
 * classi, stesso viewBox, stesso tracciato preso dalla definizione
 * dell'icona), quindi l'aspetto e i fogli di stile non cambiano. Fa solo
 * quello che serve all'elenco: classe, stile, titolo e clic.
 */
export default function IconaFa({icon, className, style, title, onClick}) {
  const [larga, alta, , , tracciato] = (icon && icon.icon) || [0, 0, [], '', ''];
  const tracciati = Array.isArray(tracciato) ? tracciato : [tracciato];
  return (
    <svg
      data-prefix={icon && icon.prefix}
      data-icon={icon && icon.iconName}
      className={'svg-inline--fa fa-' + (icon && icon.iconName) + (className ? ' ' + className : '')}
      style={style}
      viewBox={'0 0 ' + larga + ' ' + alta}
      role={'img'}
      aria-hidden={title ? undefined : 'true'}
      onClick={onClick}
    >
      {title && <title>{title}</title>}
      {tracciati.map((d, i) => <path key={i} fill={'currentColor'} d={d}/>)}
    </svg>
  );
}
